import { render, staticRenderFns } from "./CheckboxGridSelect.vue?vue&type=template&id=31888530&scoped=true"
import script from "./CheckboxGridSelect.vue?vue&type=script&lang=js"
export * from "./CheckboxGridSelect.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGridSelect.vue?vue&type=style&index=0&id=31888530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31888530",
  null
  
)

export default component.exports